import { takeEvery } from 'redux-saga'
import { put, call, select } from 'redux-saga/effects'
import { createCameraSelector } from 'selectors'
import { CREATE_CAMERA, addCameraAction, setCameraToActiveAction } from 'actions/cameraActions'
import { updatePresentationValuesAction } from 'actions/presentationActions'
import chooseNextProperId from 'helpers/chooseNextProperId'
import determineLocationOfNewDevice from 'helpers/map/determineLocationOfNewDevice'
import getMapViewportDistance from 'helpers/map/getMapViewportDistance'
import { notifyHoneybadgerAction, reverseGeocodeLocationAction } from 'actions/applicationActions'

export function * createCamera(action) {
  try {
    const { cameraIds, map, titleChanged, isImperial, devices } = yield select(createCameraSelector)

    const id = yield call(chooseNextProperId, cameraIds)
    const location = action.location ? action.location.toJSON() : (yield call(determineLocationOfNewDevice, { map, devices, isImperial }))

    if (devices.length === 0 && !titleChanged) {
      yield put(reverseGeocodeLocationAction(location))
    }

    const distance = yield call(getMapViewportDistance, map)
    yield put(addCameraAction(id, location, distance * 0.9))
    yield put(setCameraToActiveAction(id))
    yield put(updatePresentationValuesAction())
  } catch (err) {
    yield put(notifyHoneybadgerAction(err, action))
  }
}

/** Watch for create camera action, then call function */
export function * watchCreateCamera() {
  yield * takeEvery(CREATE_CAMERA, createCamera)
}



// WEBPACK FOOTER //
// ./src/sagas/createCameraSaga.js